export default "__VITE_ASSET__0aEDgsqz__"